import { useSignIn } from 'react-auth-kit';
import config from '../config.json';
import axios from '../utils/axiosInstance';
import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, useMediaQuery, useTheme } from '@mui/material';
import loginImg from '../assets/undraw_login_re_4vu2.svg';
import url from '../url.json';

export const Login = ({ open, setOpen, setOpenRegister }) => { 
    const navigate = useNavigate();
    const login = useSignIn();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [role, setRole] = useState('student');
    const [data, setData] = useState({
        email: "",
        password: ""
    });
    useEffect(() => {
        if (!open) return; 
    }, [open]);
    
    
    // 移除原本的跳轉邏輯，改為在登入成功後直接跳轉




    const handleChange = (e) => {
        const value = e.target.value;
        setData({
            ...data,
            [e.target.name]: value
        });
    };

    const handleRoleChange = (event) => {
      setRole(event.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // 檢查是否已選擇角色
        if (!role) {
            alert("請先選擇您的身分（教師或學生）");
            return;
        }
        
        const userData = {
            email: data.email,
            password: data.password,
            role: role // 將選擇的角色一起發送到後端
        };
        
        await axios
            .post(url.backendHost + config.login, userData)
            .then((response) => {
                // 儲存使用者資料和角色
                localStorage.setItem('jwtToken', response.data.jwtToken);
                localStorage.setItem('userId', response.data.id);
                localStorage.setItem('name', response.data.name);
                localStorage.setItem('email', response.data.email);
                localStorage.setItem('userRole', role); // 儲存選擇的角色
                
                login({
                    token: response.data.jwtToken,
                    expiresIn: 3600,
                    tokenType: "Bearer",
                    authState: { ...response.data, role: role },
                });
                
                // 先關閉 Dialog 和清除資料，確保 backdrop 正確關閉
                setOpen(false);
                setData({
                  email: "",
                  password: ""
                });
                
                // 使用 setTimeout 確保 Dialog 完全關閉後再跳轉
                setTimeout(() => {
                    // 根據角色跳轉到對應頁面
                    if (role === 'student') {
                        navigate("/student/my-courses"); // 學生登入後進入課程畫面
                    } else if (role === 'teacher') {
                        navigate("/teacher/preparation");
                    }
                }, 100); // 給 Dialog 關閉動畫時間（Material-UI 預設動畫時間約 225ms，100ms 足夠）
                
                // 移除 alert，避免觸發瀏覽器通知（藍色小圓點）
                // 登入成功會自動跳轉，不需要額外提示
            })
            .catch((error) => {
                if (error.response === undefined) {
                    alert("後端伺服器連結失敗");
                    return;
                }else{
                    switch (error.response.status) {
                        case 401:
                            alert("登入授權失敗 請確認帳號密碼");
                            break;
                        default:
                            alert("未知錯誤 請聯絡管理員: "+error.response.status);
                    }
                }
            });
    };
  
    return (
      <div>
        <Dialog 
          open={open} 
          onClose={() => setOpen(false)}
          maxWidth="sm"
          fullWidth
          sx={{
            zIndex: 2000,
            '& .MuiDialog-paper': {
              zIndex: 2000,
              margin: { xs: '16px', sm: '32px' },
              maxWidth: { xs: 'calc(100% - 32px)', sm: '500px' },
              maxHeight: { xs: 'calc(100% - 32px)', sm: '90vh' }
            }
          }}
          PaperProps={{
            sx: {
              zIndex: 2000,
              maxHeight: { xs: '90vh', sm: '90vh' },
              overflow: 'auto'
            }
          }}
        >
            <div style={{ textAlign: 'center', padding: '10px' }}>
                <img 
                  src={loginImg} 
                  alt="Login Illustration" 
                  style={{ 
                    width: 'auto', 
                    height: 'auto', 
                    maxWidth: '150px', 
                    maxHeight: '100px',
                    objectFit: 'contain'
                  }} 
                />
            </div>
            <DialogTitle sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }}>登入</DialogTitle>
            <DialogContent sx={{ 
              padding: { xs: '16px', sm: '24px' },
              '& .MuiTextField-root': {
                marginBottom: { xs: '8px', sm: '16px' }
              }
            }}>
                <TextField
                    autoFocus
                    margin="dense"
                    id="email"
                    label={"請填寫信箱"}
                    type="email"
                    name='email'
                    value={data.email}
                    fullWidth
                    variant="standard"
                    onChange={handleChange}
                />
                <TextField
                    margin="dense"
                    id="password"
                    label={"請填入密碼"}
                    type="password"
                    name='password'
                    value={data.password}
                    fullWidth
                    variant="standard"
                    onChange={handleChange}
                />
                <FormControl sx={{ 
                  mt: { xs: 1, sm: 2 }, 
                  mb: { xs: 1, sm: 2 },
                  width: '100%'
                }}>
                    <FormLabel id="demo-row-radio-buttons-group-label">身分</FormLabel>
                    <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        value={role}
                        onChange={handleRoleChange}
                        sx={{
                          flexWrap: { xs: 'wrap', sm: 'nowrap' },
                          gap: { xs: '8px', sm: '16px' }
                        }}
                    >
                        <FormControlLabel 
                          value="teacher" 
                          control={<Radio />} 
                          label="教師"
                          sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
                        />
                        <FormControlLabel 
                          value="student" 
                          control={<Radio />} 
                          label="學生"
                          sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
                        />
                    </RadioGroup>
                </FormControl>
               <DialogContentText>
                    還沒有帳號嗎？
                    <Link component="button" underline="none" onClick={() => { setOpen(false); setOpenRegister(true); }}>
                    註冊
                </Link>
            </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ 
          p: { xs: 1.5, sm: 2.5 }, 
          bgcolor: '#f8f9fa', 
          borderTop: '1px solid #e0e0e0',
          '& .MuiButton-root': {
            width: { xs: '100%', sm: 'auto' },
            minWidth: { xs: '100%', sm: '64px' }
          }
        }}>
            <Button onClick={handleSubmit} variant="contained" fullWidth={isMobile}>登入</Button>
        </DialogActions>
      </Dialog>
      </div>
    );
}